import React from 'react';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import ValidationText from '../../../utils/validation/ValidationText.js';

const ItemForm1 = (props) => {
    return (
        <div className="item-form">
            <div className="item-grp flex gap-2.5 mb-4">
                <div className="input-grp w-full">
                    <label>Sr. No.</label>
                    <input
                        type="text"
                        id="srNo"
                        name="srNo"
                        disabled
                        autocomplete="off"
                        value={props.invoiceDetails.srNo}
                        onChange={(event) =>
                            props.handleChange(event, "srNo", "invoiceDetails")
                        }
                    />
                </div>
                <div className="input-grp w-full">
                    <label>Invoice No.</label>
                    <input
                        type="text"
                        id="invoiceNo"
                        name="invoiceNo"
                        className={`inputFocus ${props.validState?.error?.invoiceNo ? "errorInput" : ""}`}
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceNo}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceNo", "invoiceDetails")
                        }
                    />
                    {/* <ValidationText error={props.validState.error.invoiceNo} /> */}
                </div>

                <div className="input-grp w-full">
                    <label>Invoice Date</label>
                    <input
                        type="date"
                        id="invoiceDate"
                        name="invoiceDate"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceDate}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceDate", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-full">
                    <label>Rept. Date</label>
                    <input
                        type="date"
                        id="reptDate"
                        name="reptDate"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.reptDate}
                        onChange={(event) =>
                            props.handleChange(
                                event,
                                "reptDate",
                                "invoiceDetails"
                            )
                        }
                    />
                </div>

                <div className="input-grp min-w-[30%]">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                        drpIdentity="partyId"
                        options={props.partyDropdownList}
                        closeMenuOnSelect={true}
                        className={`inputFocus ${props.validState?.error?.partyId ? "errorInput" : ""}`}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParameters(selected, "partyId")
                        }
                        allowSelectAll={false}
                        value={props.partyDropdownList.filter(
                            (party) =>
                                party.value === props.invoiceDetails.partyId
                        )}
                    />
                    {/* <ValidationText error={props.validState.error.partyId} /> */}
                </div>
            </div>
        </div>
    );
};

export default ItemForm1;